import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { TEXT_HEADER_BASE_CLASSNAME } from './Constants';
import { createTextHeader } from './TextHeader';
createComponents(".".concat(TEXT_HEADER_BASE_CLASSNAME), createTextHeader, NO_PATTERN_BUSINESS_LOGIC);
